import * as React from "react";
import {Fragment} from "react";

class Item extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {

		const {label, icon, target, selected} = this.props;

		return (
			<Fragment>
				<li className="nav-item" role="presentation">
					<button className={`nav-link${(selected ? ' active' : '')}`} id={`pill-${target}-tab`} data-bs-toggle="pill" data-bs-target={`#${target}-tab`} type="button" role="tab" aria-controls={target} aria-selected={selected} >
						<div>
							<i className={`${icon} me-2`} /> {label}
						</div>
					</button>
				</li>
			</Fragment>
		);
	}
}

export default Item;
